import { mallTrackStd } from './track'
import { EnumUIActivitiesInProgressType } from '../defines/enums'
import { GlobalEnv } from '../global_env'

const _TrackMap = {
  index: {
    exposed() {
      mallTrackStd('wyc_ckh5_trippackage_list_home_sw', '列表页曝光', {
        city_id: GlobalEnv.locationInfo?.cityId,
      })
    },
    click(ck_type) {
      mallTrackStd('wyc_ckh5_trippackage_list_home_ck', '列表页-入口点击', {
        ck_type,
      })
    },
    moneySavingBarExposed() {
      mallTrackStd('wyc_ckh5_trippackage_list_less_sw', '列表页-省钱感知条组件')
    },
    moneySavingBarCouponsExposed() {
      mallTrackStd(
        'wyc_ckh5_trippackage_list_use_sw',
        '列表页-可用优惠券入口曝光',
        {
          coupons: this.availabelCoupons,
        }
      )
    },
    moneySavingBarHistoryExposed() {
      mallTrackStd('wyc_ckh5_trippackage_buy_his_sw', '列表页-购买历史入口曝光')
    },
    activitiesGoodsExposed() {
      mallTrackStd('wyc_ckh5_trippackage_buy_list_sw', '列表页-套餐曝光', {
        package_id: this.goodsList.map(good => good.goods_id),
        pop_type:
          this.type === EnumUIActivitiesInProgressType.Recommends
            ? _TrackMap.index.activitiesGoodsExposed.PopType.Recommend
            : _TrackMap.index.activitiesGoodsExposed.PopType.Activities,
      })
    },
    listGoodsExposed(goods) {
      mallTrackStd('wyc_ckh5_trippackage_buy_list_sw', '列表页-套餐曝光', {
        package_id: goods
          .slice(0, this.hasRecommend ? 3 : 5)
          .map(good => good.goods_id),
        pop_type: _TrackMap.index.listGoodsExposed.PopType.List,
      })
    },
    nextPage({ row_type }) {
      mallTrackStd('wyc_ckh5_trippackage_rows_sw', '列表页-滑屏', {
        row_type,
      })
    },
    recommendGoodsExposed() {
      const package_info = this.goodsList.map(good => ({
        goods_id: good.goods_id,
        pop_type:
          this.type === EnumUIActivitiesInProgressType.Recommends
            ? _TrackMap.index.activitiesGoodsExposed.PopType.Recommend
            : _TrackMap.index.activitiesGoodsExposed.PopType.Activities,
        package_type: good.is_spike,
        is_dim_p: good.is_dim_p,
      }))
      mallTrackStd(
        'wyc_trippackage_valuerecommen_goods_sw',
        '套餐列表页超值推荐区商品曝光',
        {
          package_info: JSON.stringify(package_info),
          city_id: GlobalEnv.locationInfo.cityId,
        }
      )
    },
    activitiesGoodsClick({
      goods_id: package_id,
      is_spike: package_type,
      is_dim_p,
    }) {
      mallTrackStd('wyc_ckh5_trippackage_buy_his_ck', '列表页-超值推荐区点击', {
        package_id,
        ck_type:
          this.type === EnumUIActivitiesInProgressType.Recommends
            ? _TrackMap.index.activitiesGoodsClick.CKType.Recommend
            : _TrackMap.index.activitiesGoodsClick.CKType.Activities,
        package_type,
        city_id: GlobalEnv.locationInfo.cityId,
        is_dim_p,
      })
    },
    changeTab(tab_id) {
      mallTrackStd('wyc_ckh5_trippackage_cat_tab_ck', '列表页-品类tab点击', {
        tab_id,
      })
    },
    tabExposed(tab_id) {
      mallTrackStd('wyc_ckh5_trippackage_cat_tab_sw', '列表页-品类tab曝光', {
        tab_id,
      })
    },
  },
  personal: {
    exposed(tab) {
      mallTrackStd('wyc_ckh5_tentask_package_paid_sw', '购买记录页曝光', {
        ...(tab?.omegaAttr_sw || {}),
      })
    },
    changeTab(tab) {
      mallTrackStd('wyc_ckh5_tentask_package_paid_ck', '购买记录页tab点击', {
        ...(tab?.omegaAttr_ck || {}),
      })
    },
    goDetail(package_id, order_status) {
      mallTrackStd(
        'wyc_ckh5_tentask_package_det_ck',
        '购买记录页-查看详情点击',
        {
          package_id,
          order_status,
        }
      )
    },
    goRide(package_id) {
      mallTrackStd(
        'wyc_ckh5_tentask_package_car_ck',
        '购买记录页-去打车button点击',
        {
          package_id,
        }
      )
    },
  },
}

_TrackMap.index.click.CKType = {
  ShareBtn: 1,
  ChangeCity: 2,
  Personal: 3,
  History: 4,
}

_TrackMap.index.activitiesGoodsExposed.PopType = {
  Recommend: 1,
  Activities: 2,
  List: 3,
}

_TrackMap.index.listGoodsExposed.PopType = {
  List: 3,
}

_TrackMap.index.activitiesGoodsClick.CKType = {
  Recommend: 1,
  Activities: 2,
}

export const TrackMap = _TrackMap
